export const weekDays = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
export const COLOR_BY_STORAGE_KEY = 'color_by_storage_key';
export const BOARD_STORAGE_KEY = 'board_storage_key';

export const radiosTabs = [
    {name: 'Teachers', value: 'Teachers'},
    {name: 'Levels', value: 'Levels'},
    {name: 'Style', value: 'Styles'},
];

export const tabSwitcher = [
    {
        label: "Info",
        value: "Info"
    },
    {
        label: "Schedule",
        value: "Schedule"
    },
    {
        label: "Students",
        value: "Students"
    }
];

export const timeSlotInterval = {
    minutes_5: 5,
    minutes_15: 15
}

export const classDuration = {
    min: {
        minutesInterval_5: 15,
        minutesInterval_15: 15
    },
    max: 240
}

export const TIME_SLOTS = {
    MINUTES_5: '00:05',
    MINUTES_15: '00:15'
}


export const DAY_MIN_WIDTH = {
    LITTLE_WIDTH: 80,
    BIG_WIDTH: 180
}
